<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg'
    variant?: 'default' | 'onDark'
  }>(),
  {
    size: 'md',
    variant: 'default',
  },
)

const sizeClass = {
  sm: 'hr-spinner-sm',
  md: 'hr-spinner-md',
  lg: 'hr-spinner-lg',
} as const
</script>

<template>
  <span
    class="hr-spinner shrink-0"
    :class="[
      sizeClass[size],
      variant === 'onDark' && 'hr-spinner--on-dark',
    ]"
    aria-hidden="true"
  />
</template>
